module.exports = __webpack_public_path__ + "img/login-v2-dark.58db2eaf.svg";